import { useRouter } from "next/navigation";

import { useStore } from "@/store";
import { useTeamChats } from "@/store/useTeamChats";
import { chatPageUrl } from "@/urls";

export function useCreateChat() {
  const { view } = useStore();
  const teamChats = useTeamChats();
  const router = useRouter();

  const createChat = async () => {
    const chat = await teamChats.createChat();
    if (chat) {
      teamChats.editChatMap.set(chat);
      // Navigating closes the phone panel, taking the rename field with it
      if (!view.isMobileDocsVisible) {
        router.push(chatPageUrl({ chatId: chat.uid }));
      }
    }
  };

  return { createChat, isCreating: teamChats.creatingChatStatus === "creating" };
}
